import { exceptions } from "../../errors";

export function Entity(){
  throw exceptions.Type(`Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.`);
}
